var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 821,
    height: 821,
    viewBox: "0 0 821 821",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M431.125 534.6V369H348.625V410.4H389.875V534.6H328V576H493V534.6H431.125Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M410 245C401.778 245 393.893 248.266 388.08 254.08C382.266 259.893 379 267.778 379 276C379 284.222 382.266 292.107 388.08 297.92C393.893 303.734 401.778 307 410 307C418.222 307 426.107 303.734 431.92 297.92C437.734 292.107 441 284.222 441 276C441 267.778 437.734 259.893 431.92 254.08C426.107 248.266 418.222 245 410 245Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M410.5 769.687C315.238 769.687 223.877 731.845 156.516 664.484C89.1554 597.123 51.3125 505.762 51.3125 410.5C51.3125 315.238 89.1554 223.877 156.516 156.516C223.877 89.1554 315.238 51.3125 410.5 51.3125C505.762 51.3125 597.123 89.1554 664.484 156.516C731.845 223.877 769.687 315.238 769.687 410.5C769.687 505.762 731.845 597.123 664.484 664.484C597.123 731.845 505.762 769.687 410.5 769.687ZM410.5 102.625C370.069 102.625 330.034 110.588 292.681 126.061C255.328 141.533 221.388 164.211 192.799 192.799C164.211 221.388 141.533 255.328 126.061 292.681C110.588 330.034 102.625 370.069 102.625 410.5C102.625 450.931 110.588 490.966 126.061 528.319C141.533 565.672 164.211 599.612 192.799 628.2C221.388 656.789 255.328 679.467 292.681 694.939C330.034 710.412 370.069 718.375 410.5 718.375C492.154 718.375 570.463 685.938 628.2 628.2C685.938 570.463 718.375 492.154 718.375 410.5C718.375 328.846 685.938 250.537 628.2 192.799C570.463 135.062 492.154 102.625 410.5 102.625Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.6b7b3940610340230bf29022bf34af10.svg";
export { ForwardRef as ReactComponent };